import { Bell, Flame, Scissors, Sprout, type LucideIcon } from 'lucide-react';
import type { ZoneId } from '../types';

/**
 * Distinct icon SHAPE per zone so the four zones never rely on color alone
 * (the red/green emoji dots are indistinguishable for ~8% of men with
 * color-vision deficiency). Shapes carry the meaning: flame = urgent fire,
 * sprout = growth, bell = others' demands, scissors = cut it out.
 */
const ZONE_ICONS: Record<ZoneId, LucideIcon> = {
  zone1: Flame,
  zone2: Sprout,
  zone3: Bell,
  zone4: Scissors,
};

export function ZoneIcon({
  zone,
  size = 14,
  className = '',
}: {
  zone: ZoneId;
  size?: number;
  className?: string;
}) {
  const Icon = ZONE_ICONS[zone];
  return <Icon size={size} className={className} aria-hidden />;
}
